var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.closeable)?_c('lord-icon',{staticClass:"emat-close",staticStyle:{"width":"36px","height":"36px"},attrs:{"src":"https://cdn.lordicon.com/dfyonbvl.json","trigger":"hover","colors":_vm.getColors},on:{"click":_vm.close}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }